import { getMyPermissionAccess, PermissionInfo } from '@adornis/abac/policies/SimpleRolePolicy.js';
import { Entity } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { context } from '@adornis/baseql/server/context.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { SmartTeamsPermission } from '../roles-and-permissions.js';

export const getFieldEngineerFilter = registerQuery({
  type: () => MongoFieldEngineerFilter,
  operationName: 'getFieldEngineerFilter',
  resolve: (companyFilterId?: string) => {
    return async (_gqlFields: BaseQLSelectionSet<MongoFieldEngineerFilter>) => {
      if (context.serverContext) {
        return new MongoFieldEngineerFilter({
          hasAccess: true,
          isGlobal: true,
          companyFilterId,
        });
      }
      const permissionInfo = await getMyPermissionAccess(SmartTeamsPermission.FERead)({
        allowedContexts: 1,
        hasAccess: 1,
        isGlobal: 1,
      });

      return new MongoFieldEngineerFilter({
        ...permissionInfo.toObject(),
        companyFilterId,
      });
    };
  },
  params: [{ name: 'companyFilterId', type: () => String }],
});

@Entity()
export class MongoFieldEngineerFilter extends PermissionInfo {
  static override _class = 'MongoFieldEngineerFilter';

  companyFilterId?: string;

  parseMongoFilter() {
    if (!this.hasAccess) return { _id: null as any };

    const companyFilter = this.companyFilterId ? { partnerCompanyIds: this.companyFilterId } : {};

    if (this.isGlobal) return companyFilter;
    // Non-global (e.g. Partner Manager): `allowedContexts` are COMPANY ids, so match them against
    // the FE's `partnerCompanyIds`, not the FE `_id` (which never equals a company id → no results).
    return {
      $and: [{ partnerCompanyIds: { $in: this.allowedContexts } }, companyFilter].filter(f => Object.keys(f).length > 0),
    };
  }

  constructor(doc: PartialEntityData<MongoFieldEngineerFilter>) {
    super(doc);
  }
}
